import type { FunctionComponent } from 'react';
import { useContext, useEffect } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { route } from './constants';

export const OnboardingForwarder: FunctionComponent = () => {
    const { actions, applicationState } = useContext(ApplicationContext);
    const { location, myUserProfile } = applicationState;
    const { navigateTo } = actions;

    const isCurrentPageOnboarding = location.pathname.includes(route.patterns.onboarding);

    useEffect(() => {
        const myUserProfileExists = myUserProfile.get('exists').unwrapOr(undefined);

        if (myUserProfileExists === false && !isCurrentPageOnboarding) {
            navigateTo(route.patterns.onboarding);
        }
    }, [myUserProfile, isCurrentPageOnboarding, navigateTo]);

    return null;
};
